export default "__VITE_ASSET__ByeFH_nP__"